import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { JsonLd } from "@/components/JsonLd";
import { Faq } from "@/components/Faq";
import { AdSlot } from "@/components/AdSlot";
import { Card } from "@/components/ui/card";
import SchuettgutRechner from "@/components/schuettgut/SchuettgutRechner";
import { SCHUETTGUT_SEITEN, SCHUETTGUT_HUB } from "@/lib/schuettgutSeiten";

export default function SchuettgutHubPage() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const canonical = origin ? `${origin}/${SCHUETTGUT_HUB.slug}` : undefined;

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name: "Kies- und Schüttgut-Rechner",
      url: canonical,
      applicationCategory: "UtilityApplication",
      operatingSystem: "Web",
      offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" },
      inLanguage: "de-DE",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: SCHUETTGUT_HUB.faq.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ];

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <Seo title={SCHUETTGUT_HUB.title} description={SCHUETTGUT_HUB.description} canonical={canonical} />
      <JsonLd data={jsonLd} />

      <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">{SCHUETTGUT_HUB.h1}</h1>
      <p className="mt-3 text-muted-foreground leading-relaxed">
        Wähle das Material, gib Fläche und Schütthöhe ein und du bekommst sofort die benötigte Menge in Kubikmeter, das Gewicht in Tonnen und die Anzahl Big Bags. Kostenlos, ohne Anmeldung.
      </p>

      <div className="mt-6">
        <SchuettgutRechner material="schotter" />
      </div>

      <div className="mt-8"><AdSlot variant="banner" /></div>

      <section className="mt-8">
        <h2 className="text-xl font-semibold mb-3">Direkt zum Material</h2>
        <div className="grid sm:grid-cols-2 gap-3">
          {SCHUETTGUT_SEITEN.map((s) => (
            <Link key={s.slug} to={`/${s.slug}`} className="block">
              <Card className="p-4 h-full hover:shadow-md transition-shadow">
                <div className="font-semibold text-sm">{s.h1}</div>
                <div className="text-sm text-muted-foreground mt-1">{s.description}</div>
              </Card>
            </Link>
          ))}
        </div>
      </section>

      <section className="mt-10">
        <h2 className="text-xl font-semibold mb-4">Häufige Fragen</h2>
        <Faq items={SCHUETTGUT_HUB.faq} testId="schuettgut-hub-faq" />
      </section>

      <div className="mt-10"><AdSlot variant="banner" /></div>
    </div>
  );
}
